import { useApolloClient } from "@apollo/client";
import { Link, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { Link as RouterLink } from "react-router-dom";
import { namedOperations } from "../../../clients/graphqlTypes.js";
import { Attachment } from "../attachments/helpers.js";
import { UserAvatar } from "../users/UserAvatar.js";
import {
  MyOrganisationUserAvatarAndTitleData_UserFragment,
  useModifyUserAvatarMutation,
} from "./MyOrganisationUserAvatarAndTitle.generated.js";

interface Props {
  user: MyOrganisationUserAvatarAndTitleData_UserFragment;
}

export const ViewerAvatarAndTitleForm = ({ user }: Props) => {
  const { t } = useTranslate(["UserProfile", "Global"]);
  const client = useApolloClient();
  const [modifyUser, { loading: modifyUserLoading }] =
    useModifyUserAvatarMutation({
      client,
      refetchQueries: [namedOperations.Query.MyOrganisationUserProfile],
    });
  const onAttachment = async (attachment: Attachment | null) => {
    await modifyUser({
      variables: {
        user: {
          avatar: attachment
            ? {
                url: attachment.url,
                title: attachment.title,
                mimeType: attachment.mimeType,
              }
            : null,
        },
      },
    });
  };
  return (
    <Stack direction="column" spacing={1}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
        }}
      >
        <UserAvatar
          userAvatar={user}
          size="l"
          onAttachment={onAttachment}
          disabled={modifyUserLoading}
        />
      </Stack>
      <Stack direction="column" spacing={0.5}>
        <Typography variant="h2" align="center">
          {user.firstname} {user.familyname}
        </Typography>
        <Link
          component={RouterLink}
          to={`/organisation`}
          sx={{ alignSelf: "center", textAlign: "center" }}
        >
          {`${user.organisationTitle}${user.membershipStatus === "DEACTIVATED" ? ` (${t("Deactivated", { ns: "Global" })})` : ""}`}
        </Link>
      </Stack>
    </Stack>
  );
};

export const MyOrganisationUserAvatarAndTitleData = ({ user }: Props) => {
  const { t } = useTranslate(["UserProfile", "Global"]);
  return (
    <Stack direction="column" spacing={1}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
        }}
      >
        <UserAvatar userAvatar={user} size="l" />
      </Stack>
      <Stack direction="column" spacing={0.5}>
        <Typography variant="h2" align="center">
          {user.firstname} {user.familyname}
        </Typography>
        <Link
          component={RouterLink}
          to={`/organisation`}
          sx={{ alignSelf: "center", textAlign: "center" }}
        >
          {`${user.organisationTitle}${user.membershipStatus === "DEACTIVATED" ? ` (${t("Deactivated", { ns: "Global" })})` : ""}`}
        </Link>
      </Stack>
    </Stack>
  );
};
